/* biome-ignore-all lint/style/noParameterAssign: Need to pass ref for forwardRef */
/* biome-ignore-all lint/performance/noNamespaceImport: Cleaner when working with libraries */
'use client';

import * as Accordion from '@radix-ui/react-accordion';
import { forwardRef } from 'react';
import { cn } from '@/app_lib/utils/utils';

const Root = forwardRef<
  React.ComponentRef<typeof Accordion.Root>,
  React.ComponentPropsWithoutRef<typeof Accordion.Root>
>(({ className, children, ...rest }, ref) => (
  <Accordion.Root
    className={cn(className)}
    ref={ref}
    {...rest}
  >
    {children}
  </Accordion.Root>
));
Root.displayName = 'AccordionRoot';

const Header = forwardRef<
  React.ComponentRef<typeof Accordion.Header>,
  React.ComponentPropsWithoutRef<typeof Accordion.Header>
>(({ className, children, ...rest }, ref) => (
  <Accordion.Header
    className={cn(className)}
    ref={ref}
    {...rest}
  >
    {children}
  </Accordion.Header>
));
Header.displayName = 'AccordionHeader';

const Item = forwardRef<
  React.ComponentRef<typeof Accordion.Item>,
  React.ComponentPropsWithoutRef<typeof Accordion.Item>
>(({ className, ...rest }, ref) => (
  <Accordion.Item
    className={cn(className)}
    ref={ref}
    {...rest}
  />
));
Item.displayName = 'AccordionItem';

const Trigger = forwardRef<
  React.ComponentRef<typeof Accordion.Trigger>,
  React.ComponentPropsWithoutRef<typeof Accordion.Trigger>
>(({ className, children, ...props }, ref) => (
  <Accordion.Header className='flex text-current'>
    <Accordion.Trigger
      className={cn(
        'cursor-pointer accordion-header [&[data-state=open]>svg]:rotate-180 hover:text-brand-primary group text-current',
        className,
      )}
      ref={ref}
      {...props}
    >
      {children}
    </Accordion.Trigger>
  </Accordion.Header>
));
Trigger.displayName = 'AccordionTrigger';

const Content = forwardRef<
  React.ComponentRef<typeof Accordion.Content>,
  React.ComponentPropsWithoutRef<typeof Accordion.Content>
>(({ className, children, ...props }, ref) => (
  <Accordion.Content
    className='accordion-body data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down'
    ref={ref}
    {...props}
  >
    <div className={cn(className)}>{children}</div>
  </Accordion.Content>
));
Content.displayName = 'AccordionContent';

export { Root, Header, Item, Trigger, Content };
